
// import React, {  useMemo } from 'react';
// import { Calendar } from 'lucide-react';
// import CalendarHeader from './Calendar/CalendarHeader';
// import CalendarDay from './Calendar/CalendarDay';
// import CalendarLegend from './Calendar/CalendarLegend';


// const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

// const CalendarFrame = ({ currentDate, selectedDate, onDateSelect, onMonthChange, getBookingsCount, isDateAvailable }) => {
//   const calendarDays = useMemo(() => {
//     const year = currentDate.getFullYear();
//     const month = currentDate.getMonth();
//     const firstDay = new Date(year, month, 1);
//     const lastDay = new Date(year, month + 1, 0);
//     const firstDayWeekday = firstDay.getDay();
//     const daysInMonth = lastDay.getDate();

//     const days = [];

//     // Empty cells for days before the first day of the month
//     for (let i = 0; i < firstDayWeekday; i++) {
//       days.push(null);
//     }

//     // Days of the month
//     for (let day = 1; day <= daysInMonth; day++) {
//       days.push(new Date(year, month, day));
//     }

//     return days;
//   }, [currentDate]);

//   return (
//     <div className="border-2 border-gray-200 rounded-xl p-4">
//       <div className="flex items-center justify-between mb-4">
//         <h3 className="text-lg font-semibold text-gray-800">Select Date</h3>
//         <Calendar className="text-yellow-500" size={20} />
//       </div>

//       <CalendarHeader currentDate={currentDate} onMonthChange={onMonthChange} />

//       {/* Weekdays */}
//       <div className="grid grid-cols-7 gap-1 mb-2">
//         {WEEKDAYS.map(day => (
//           <div key={day} className="text-center text-xs font-semibold text-gray-600 p-2">
//             {day}
//           </div>
//         ))}
//       </div>

//       {/* Calendar Days */}
//       <div className="grid grid-cols-7 gap-1">
//         {calendarDays.map((date, index) => (
//           <CalendarDay
//             key={index}
//             date={date}
//             isSelected={selectedDate && date?.toDateString() === selectedDate.toDateString()}
//             onSelect={onDateSelect}
//             getBookingsCount={getBookingsCount}
//             isDateAvailable={isDateAvailable}
//           />
//         ))}
//       </div>

//       {/* <CalendarLegend /> */}
//     </div>
//   );
// };

import React, { useState, useEffect, useMemo } from 'react';
import moment from 'moment';
import { Calendar } from 'lucide-react';
import CalendarHeader from './Calendar/CalendarHeader';
import CalendarDay from './Calendar/CalendarDay';
import ApiService from "../../api/ApiService.js";

const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

const CalendarFrame = ({
  currentDate,
  selectedDate,
  onDateSelect,
  onMonthChange,
  getBookingsCount,
}) => {
  const [disabledDates, setDisabledDates] = useState([]);
  // console.log("disabledDates", disabledDates);

  // Fetch disabled dates from backend
  useEffect(() => {
    const fetchDisabledDates = async () => {
      try {
        const response = await ApiService.getEkadashiDateList();

        // Extract and format dates from the response objects
        const formattedDates = response.data
          .filter(item => !item.deleted) // Only include non-deleted dates
          .map(item => moment(item.date).format("YYYY-MM-DD"));

        console.log("Formatted disabled dates:", formattedDates);
        setDisabledDates(formattedDates);
      } catch (error) {
        console.error('Error fetching disabled dates:', error);
        setDisabledDates([]); // Set empty array on error
      }
    };

    fetchDisabledDates();
  }, [currentDate]); // refetch if month changes

  // Generate calendar days
  const calendarDays = useMemo(() => {
    const startOfMonth = moment(currentDate).startOf('month');
    const endOfMonth = moment(currentDate).endOf('month');
    const firstDayWeekday = startOfMonth.day();
    const daysInMonth = endOfMonth.date();

    const days = [];

    for (let i = 0; i < firstDayWeekday; i++) {
      days.push(null);
    }

    for (let day = 1; day <= daysInMonth; day++) {
      days.push(moment(startOfMonth).date(day).toDate());
    }

    return days;
  }, [currentDate]);

  // Check if date is available
  const isDateAvailable = (date) => {
    if (!date) return false; // for empty cells
    const dateStr = moment(date).format("YYYY-MM-DD");
    return !disabledDates.includes(dateStr); // true if not disabled
  };

  return (
    <div className="border border-secondary rounded-3 p-3">
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0 fw-semibold text-dark">Select Date</h5>
        <Calendar className="text-warning" size={20} />
      </div>

      <CalendarHeader currentDate={currentDate} onMonthChange={onMonthChange} />

      {/* Weekdays */}
      <div className="d-flex text-center mb-2">
        {WEEKDAYS.map((day) => (
          <div key={day} className="flex-fill px-1">
            <small className="fw-semibold text-secondary">{day}</small>
          </div>
        ))}
      </div>

      {/* Calendar Days */}
      <div className="d-flex flex-wrap text-center">
        {calendarDays.map((date, index) => (
          <div
            key={index}
            className="calendar-day-box p-1"
            style={{ width: 'calc(100% / 7)' }}
          >
            <CalendarDay
              date={date}
              isSelected={
                selectedDate &&
                date &&
                moment(date).isSame(selectedDate, 'day')
              }
              onSelect={(d) => isDateAvailable(d) && onDateSelect(d)}
              getBookingsCount={getBookingsCount}
              isDateAvailable={isDateAvailable} // Pass the function reference
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CalendarFrame;